import { find, get } from "lodash";

import { CONTACT_POINT_SYSTEM, GENDER } from "utils/constants";

const GENDER_TITLE = {
  [GENDER.MALE]: "M ",
  [GENDER.FEMALE]: "Mme ",
  undefined: "",
  null: "",
};

const trimOrEmpty = (value) => {
  if (value === undefined || value === null) return "";
  const s = String(value).trim();
  return s;
};

const firstNonEmpty = (candidates) => {
  const found = candidates.find((v) => trimOrEmpty(v));
  return found !== undefined ? trimOrEmpty(found) : "";
};

const getOrganizationTelecomValue = (ctx, system) => {
  const telecoms = get(ctx, "organization.telecoms", []);
  const entry = find(telecoms, { system });
  return trimOrEmpty(get(entry, "value"));
};

const getOrganizationPhone = (ctx) =>
  firstNonEmpty([
    getOrganizationTelecomValue(ctx, CONTACT_POINT_SYSTEM.PHONE),
    getOrganizationTelecomValue(ctx, CONTACT_POINT_SYSTEM.LANDLINE),
  ]);

const getOrganizationEmail = (ctx) =>
  getOrganizationTelecomValue(ctx, CONTACT_POINT_SYSTEM.EMAIL);

const getAdvisorPhone = (ctx) => {
  const advisor = get(ctx, "advisor");
  if (!advisor) return "";
  return firstNonEmpty([
    get(advisor, "phone"),
    get(advisor, "mobilePhone"),
    get(advisor, "params.phone"),
    get(advisor, "params.mobilePhone"),
    get(advisor, "meta.phone"),
    get(advisor, "meta.mobilePhone"),
  ]);
};

/**
 * Variable token names (uppercase) → resolver returning display string.
 * Matching is case-insensitive; optional spaces inside {{ }} are allowed.
 */
const VARIABLE_RESOLVERS = {
  PRENOM: (ctx) => trimOrEmpty(get(ctx, "contact.user.firstname")),
  NOM: (ctx) => trimOrEmpty(get(ctx, "contact.user.lastname")),
  CIVILITE: (ctx) => trimOrEmpty(GENDER_TITLE[get(ctx, "contact.user.gender")]),
  TELEPHONE_CONSEILLER: (ctx) => getAdvisorPhone(ctx),
  EMAIL_CONSEILLER: (ctx) => trimOrEmpty(get(ctx, "advisor.email")),
  PRENOM_CONSEILLER: (ctx) => trimOrEmpty(get(ctx, "advisor.firstname")),
  NOM_CONSEILLER: (ctx) => trimOrEmpty(get(ctx, "advisor.lastname")),
  NOM_ORGANISME: (ctx) => trimOrEmpty(get(ctx, "organization.name")),
  TELEPHONE_ORGANISME: (ctx) => getOrganizationPhone(ctx),
  EMAIL_ORGANISME: (ctx) => getOrganizationEmail(ctx),
};

const escapeRegExp = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

/**
 * Replaces {{VAR}} tokens with context values. If a value is missing or blank
 * after trim, the original token is kept so phrases like "au {{TEL}} ou par
 * email" do not become "au ou par email".
 */
export const replaceVariables = (text, context) => {
  if (!text) return text;
  let result = text;
  Object.entries(VARIABLE_RESOLVERS).forEach(([name, resolver]) => {
    const pattern = new RegExp(
      `\\{\\{\\s*${escapeRegExp(name)}\\s*\\}\\}`,
      "gi",
    );
    result = result.replace(pattern, (match) => {
      const raw = resolver(context);
      const value = raw === undefined || raw === null ? "" : String(raw).trim();
      if (value === "") {
        return match;
      }
      return value;
    });
  });
  return result;
};
